export type LessonThumbnailProgressInput = {
  userProgress?: number | null;
  videoCount?: number | null;
  noOfVideos?: number | null;
  completedVideoCount?: number | null;
  leftOffAtSeconds?: number | null;
  durationSeconds?: number | null;
};

export function lessonThumbnailProgressPercent(
  m: LessonThumbnailProgressInput,
): number {
  const up = m.userProgress;
  if (up != null && Number.isFinite(Number(up))) {
    const n = Number(up);
    if (n <= 0) return 0;
    if (n <= 1) return Math.round(n * 100);
    return Math.min(100, Math.round(n));
  }
  const total = m.videoCount ?? m.noOfVideos;
  const done = m.completedVideoCount;
  if (total != null && total > 0 && done != null && done >= 0) {
    return Math.min(100, Math.round((done / total) * 100));
  }
  const left = m.leftOffAtSeconds;
  const dur = m.durationSeconds;
  if (dur != null && dur > 0 && left != null && left > 0) {
    return Math.min(100, Math.max(0, Math.round((left / dur) * 100)));
  }
  return 0;
}
